import script from "./CtaButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CtaButton.vue?vue&type=script&setup=true&lang=js"

import "./CtaButton.vue?vue&type=style&index=0&id=201e0efa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-201e0efa"]])

export default __exports__